import React from 'react';
import ReferalGuideCompoment from 'components/Tvendo/Print/ReferalGuide';

function ReferalGuide() {
  return <ReferalGuideCompoment />;
}

export default ReferalGuide;
